import "./styles.scss";
import { ReactNode } from "react";
import { isFromMobileWebView } from "../../services/header-footer";

// Static shell shown while account data loads (or fails to load) so the user
// never sees an empty white page. Renders with no data dependencies.
const PageShell = (props: { children: ReactNode }): JSX.Element => {
  return (
    <div className="page-shell">
      {!isFromMobileWebView() && (
        <header className="page-shell-header">
          <span className="page-shell-brand">Alaska Airlines</span>
        </header>
      )}
      <main className="page-shell-content">{props.children}</main>
    </div>
  );
};

export default PageShell;
